<form [formGroup]="filtersForm" (ngSubmit)="graphSubmit()">
  <div>
    <div *ngIf="graphProps.graph.dataX == StatsGraphDataX.DATE" style="display: flex; align-items: center;">
      <label>{{ 'stats.graphs.datepicker.viewSince' | translate }}{{ 'stats.common.colon' | translate }}</label>
      <div style="display: flex;">
        <mat-radio-group formControlName="period" style="display: flex; justify-content: center; align-items: center;">
          <mat-radio-button [value]=0 labelPosition="before">{{ 'stats.graphs.datepicker.always' | translate }}</mat-radio-button>
          &nbsp;&nbsp;
          <mat-radio-button [value]=1 labelPosition="after">
            <div style="display: flex; justify-content: center; align-items: center; ">
              <span>{{ 'stats.graphs.datepicker.date' | translate }}</span>
              <div style="display: inline-flex; justify-content: center; align-items: center; flex-wrap: wrap">
                <span>{{ 'stats.graphs.datepicker.from' | translate }}&nbsp;</span>
                <mat-form-field class="datePicker">
                  <input class="datePicker-input" formControlName="startDate" matInput [matDatepicker]="startsvr" [min]="statsVisitsDateMin" [max]="datenow">
                  <mat-datepicker-toggle matSuffix [for]="startsvr"></mat-datepicker-toggle>
                  <mat-datepicker #startsvr
                                  [disabled]="filtersForm.get('period').value!=1"
                                  startView="multi-year">
                  </mat-datepicker>
                </mat-form-field>
                <span>&nbsp;{{ 'stats.graphs.datepicker.to' | translate }}&nbsp;</span>
                <mat-form-field class="datePicker" style="padding: 0;">
                  <input class="datePicker-input" formControlName="endDate" matInput [matDatepicker]="endsvr" [min]="statsVisitsDateMin" [max]="datenow">
                  <mat-datepicker-toggle matSuffix [for]="endsvr"></mat-datepicker-toggle>
                  <mat-datepicker #endsvr
                                  [disabled]="filtersForm.get('period').value!=1"
                                  startView="multi-year">
                  </mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
  <div class="graph-filters-container">
    <div class="graph-filters-container-left column-items">
      <div *ngFor="let filter of graphProps.filters; index as idx">
        <stats-filter [filterProps]="getFilterPropsForKind(filter.kind)" [isRight]="false" [formGroup]="filtersForm" [previousValue]="(idx == 0) ? '' : filtersForm.controls[StatsGraphFilterKind[graphProps.filters[idx-1].kind]].value" [editValues]="editValues"></stats-filter>
      </div>
    </div>
    <div class="graph-filters-container-right column-items">
      <div class="column-items">
        <div *ngFor="let filter of graphProps.filters; index as idx">
          <stats-filter [filterProps]="getFilterPropsForKind(filter.kind)" [isRight]="true" [formGroup]="filtersForm" [previousValue]="(idx == 0) ? '' : filtersForm.controls[StatsGraphFilterKind[graphProps.filters[idx-1].kind]].value" [editValues]="editValues"></stats-filter>
        </div>
      </div>
      <div class="graph-filters-right-maxer"></div>
      <div class="graph-filters-right-button">
        <button class="search">{{ 'accountChoice.rechercher' | translate }}</button>
      </div>
    </div>
  </div>
</form>
